@if (isGlobalLoading()) {
  <app-loading></app-loading>
}

<router-outlet>
  <nav></nav>
</router-outlet>
